import { useSelector } from 'react-redux'
import { Auth0Config } from '@/types'
import { ReduxState } from '@/config/redux/types'

const selectAuth0Config = (state: ReduxState): Auth0Config => state.auth0Config
const useAuth0Config = () => useSelector(selectAuth0Config)

export { selectAuth0Config, useAuth0Config }
